import React, {useState} from 'react';
import s from './PlaceUI.module.scss';
import m from './MainUI.module.scss'
import EventBus from "scripts/util/EventBus";

import ResizeIcon from 'assets/images/dogmented/resize.svg'
import RecenterIcon from "assets/images/dogmented/recenter.svg"


export default function PlaceUI() {
  const [showHelpModal, setShowHelpModal] = useState(false)
  setTimeout(() => setShowHelpModal(true), 9000)
  
  function emitAction(name) {
    EventBus.dispatch("Action", {type: name});
  }

  return (
    <div className={s.placeui}>
      <div className={m.recenter} onClick={(e) => emitAction("recenter")}>
          <img src={RecenterIcon} alt="Recenter" />
          <span>Recenter</span>
      </div>
      {showHelpModal && <div className="overlayHeader">
        <div className={s.findOpenSpace} >
          <span>Find an open flat well lit space - if dog does not appear try pressing Recenter</span>
        </div>
      </div>}
      <div className="overlayHeader" >
        <div className={s.dialog}>
          <img src={ResizeIcon} alt="" />
          <span>Pinch To Scale</span>
        </div>
      </div>
      <div className={s.footer}>
        <button className='button' onClick={(e) => emitAction("place")}>Place</button>
      </div>
    </div>
  );
}